module.exports = __webpack_public_path__ + "img/hr-tank-base-3.8ea5a0c7.png";